import React, { FC } from 'react';
import { CustomTabsComponentProps } from './CustomTabsComponentProps';
import { Tab, Tabs } from '@mui/material';
import Box from '@mui/material/Box';
import Badge from '@ingka/badge';
import skapaColours from '@ingka/variables/colours-css';

const CustomTabsComponent: FC<CustomTabsComponentProps> = ({
  activeTab,
  tabList,
  onTabChange,
  tabErrors,
}) => {
  return (
    <Box
      sx={{
        backgroundColor: 'white',
        borderBottom: 1,
        borderColor: 'divider',
        position: 'sticky',
        top: 0,
        zIndex: 10,
      }}
    >
      <Tabs
        value={activeTab}
        onChange={onTabChange}
        aria-label="improve-tabs"
        variant="scrollable"
        scrollButtons="auto"
        sx={{
          '& .Mui-selected': {
            color: skapaColours.colourTextAndIcon1 + ' !important',
          },

          '& .MuiTab-root': {
            fontWeight: 700,
            fontSize: '14px',
            textTransform: 'capitalize',
            color: skapaColours.colourTextAndIcon3,
          },
        }}
      >
        {tabList.map((tab) => (
          <Tab
            key={tab.value}
            data-testid={`${tab.value.toLowerCase()}-tab`}
            iconPosition="end"
            icon={
              tabErrors?.[tab.value] > 0 ? (
                <Badge
                  label={`${tabErrors[tab.value]}`}
                  colour="red"
                  size="small"
                />
              ) : undefined
            }
            sx={{
              '&.MuiTab-root span': {
                backgroundColor: 'transparent',
                transition: 'none',
              },

              '&.MuiTab-root div.MuiTab-iconWrapper': {
                marginBottom: 0,
                marginLeft: '3px',
              },
            }}
            {...tab}
          />
        ))}
      </Tabs>
    </Box>
  );
};

export default CustomTabsComponent;
